module.exports = __webpack_public_path__ + "static/media/8_The final lesson_SO.231d603f.txt";